// extracted by mini-css-extract-plugin
export default {"wrapper":"ObjectCell_wrapper__Tcw4W","fixed_message":"ObjectCell_fixed_message__ZGLYE","message":"ObjectCell_message__MuIW9"};